import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardBaseTwoComponent } from './components/dashboard-base-two/dashboard-base-two.component';
import { DashboardBaseComponent } from './components/dashboard-base/dashboard-base.component';
import { FeedsListComponent } from './components/feeds-list/feeds-list.component';
import { FeedsComponent } from './components/feeds/feeds.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { JobOpeningsListComponent } from './components/job-openings-list/job-openings-list.component';
import { JobOpeningsComponent } from './components/job-openings/job-openings.component';
import { TechQuestionsListComponent } from './components/tech-questions-list/tech-questions-list.component';
import { TechQuestionsComponent } from './components/tech-questions/tech-questions.component';
import { UsersListComponent } from './components/users-list/users-list.component';

const routes: Routes = [
  {path:"add_feed/:id",component:FeedsComponent},
  {path:"feeds",component:FeedsListComponent},
  {path:"techquestions",component:TechQuestionsListComponent},
  {path:"techquestion/:id",component:TechQuestionsComponent},
  {path:"jobOpenings",component:JobOpeningsListComponent},
  {path:"jobOpening/:id",component:JobOpeningsComponent},
  {path:"",redirectTo:"home",pathMatch:"full"},
  {path:"home",component:DashboardBaseComponent},
  {path:"home_detail/:id",component:DashboardBaseTwoComponent},
  {path:"home/:id",component:DashboardBaseTwoComponent},
  {path:"userList",component:UsersListComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
